var React = require('react');

function Vector (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.000296681 0H24.4565V3.05703H0.000296681V0Z","key":0}),React.createElement("path",{"d":"M0 8.1521H24.4562V11.2091H0V8.1521Z","key":1})]);
}

Vector.defaultProps = {"width":"25","height":"12","viewBox":"0 0 25 12"};

module.exports = Vector;

Vector.default = Vector;
